import React, { Component } from "react";
import { connect } from "react-redux";
import format from "date-fns/format";
import { DIMENSIONS } from "services/layoutManager";
import BloxPage from "sub_components/Layout/BloxPage";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { BloxButton } from "styled_components/Common/BloxButton";
import BadgeModal from "sub_components/Profile/BadgeModal";
import LoadingCube from "sub_components/Common/LoadingCube";
import { AddUserDataProvider } from "context/AddUserContext";
import { ActivationModalBody } from "styled_components/Account/ActivationModalBody";
import { UserDetails } from "styled_components/Account/UserDetails";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { UserProfileApi } from "services/userProfile";
import { SERVICE_IDS } from "services/utils";
import { Utils } from "services/utils";
import { AvatarApi } from "services/avatar";
import { RESOLUTIONS } from "services/config";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { MENU as PROFILE_MENU } from "utils/ProfileConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import CustomCarousel from "sub_components/Common/CustomCarousel";
import { ActionButton } from "styled_components/Common/ActionButton";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import { UserApi } from "services/user";
import { updateUsers } from "actions/company";
import { Permissions } from "services/permissions";
import CardScroller from "sub_components/Common/CardScroller";
import SitePermissions from "blox_components/Profile/SitePermissions/SitePermissions";
import { UserAddRequest } from "blox_components/Profile/PortalUserMgmt/Components/UserAddRequest/UserAddRequest";
import { BadgeAddRequest } from "blox_components/Profile/PortalUserMgmt/Components/UserAddRequest/BadgeAddRequest";
import { setHomeTour } from "actions/tour";
import { sortUsers } from "utils/SupportUtils";
import { updatePermissions } from "actions/permissions";
import { AddUserTour } from "styled_components/Tour/AddUserTour";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride-react-19";
import { getUserPermissions, setUserPermissions } from "services/user";
import { DataCenterApi } from "services/datacenter";
import { SigningServiceApi } from "services/signing";
import { SuccessMessage, ErrorMessage } from "utils/CommonConstants";
import { CompanyProfileApi } from "services/companyProfile";
import MultipleFilter from "../../styled_components/Common/MultipleFilter";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const BadgeTemplateName = "DATA_CENTER_ACCESS_PREAUTH";
const AccessTemplateName = "DCBLOX_Data_Center_Rules_and_Regulations";

const REACT_APP_ENV = process.env.REACT_APP_ENV;
const badgeIcon = `${CDN_URL}support/badge-icon.svg`;
const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    accountManagement: { x: 0, y: 4, dim: DIMENSIONS.TWO_BY_TEN },
    userDetails: { x: 0, y: 24, dim: DIMENSIONS.TWO_BY_TEN },
    sitePermissions: { x: 0, y: 44, dim: DIMENSIONS.EIGHT_BY_TEN },
    usersList: { x: 11, y: 4, dim: DIMENSIONS.TEN_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    accountManagement: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    userDetails: { x: 1, y: 34, dim: DIMENSIONS.TWO_BY_EIGHT },
    sitePermissions: { x: 1, y: 62, dim: DIMENSIONS.EIGHT_BY_EIGHT },
    usersList: { x: 9, y: 4, dim: DIMENSIONS.TEN_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    accountManagement: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    userDetails: { x: 1, y: 48, dim: DIMENSIONS.TWO_BY_EIGHT },
    sitePermissions: { x: 1, y: 92, dim: DIMENSIONS.EIGHT_BY_EIGHT },
    usersList: { x: 9, y: 4, dim: DIMENSIONS.TEN_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};
const LAYOUT_CONFIG2 = {
  [RESOLUTIONS.LOW]: {
    accountManagement: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_TEN },
    userDetails: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_TEN },
    sitePermissions: { x: 1, y: 24, dim: DIMENSIONS.EIGHT_BY_TEN },
    usersList: { x: 12, y: 4, dim: DIMENSIONS.TEN_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    accountManagement: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    userDetails: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    sitePermissions: { x: 1, y: 32, dim: DIMENSIONS.EIGHT_BY_EIGHT },
    usersList: { x: 9, y: 4, dim: DIMENSIONS.TEN_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    accountManagement: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    userDetails: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_EIGHT },
    sitePermissions: { x: 1, y: 54, dim: DIMENSIONS.EIGHT_BY_EIGHT },
    usersList: { x: 9, y: 4, dim: DIMENSIONS.TEN_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class UserMgmtPage extends Component {
  constructor(props) {
    super(props);
    this.avatarApi = new AvatarApi();
    this.companyApi = new CompanyProfileApi();
    this.userProfileApi = new UserProfileApi();
    this.state = {
      users: null,
      userError: null,
      rosterUsers: [],
      selectedFilters: ["active"],
      currentId: null,
      badges: null,
      selectedUserDetails: null,
      userDetailsLoaded: false,
      rosterUserDetails: null,
      pages: null,
      selectedModule: "Account",
      selectedInformation: "user",
      selectedUsersPages: null,
      loggedInUsersRole: null,
      selectedToggle: "portal",
      pagesError: null,
      pagesLoaded: false,
      showBadgeModal: false,
      showUserAddModal: false,
      showDCAddModal: false,
      tourClosed: false,
      tourSelected: null,
      stepIndex: 0,
      owners: [],
    };
  }

  getOrgOwners = () => {
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;

    UserApi.getOrgOwners(id)
      .then((response) => {
        this.setState({ owners: response?.data?.organizationUsers });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
      location,
      setHomeTour,
      tour: { runHomeTour: { runHomeTour } } = {},
    } = this.props;

    Utils.addScroll();
    this.getOrgOwners();
    addPageToBreadCrumbs(
      SITE_PAGES.PROFILE[PROFILE_MENU.ACCOUNT_MANAGEMENT],
      SITE_MODULES.ACCOUNT
    );
    updatePage(SITE_PAGES.PROFILE[PROFILE_MENU.ACCOUNT_MANAGEMENT]);

    if (site?.module !== "ACCOUNT" || !permissions?.permissions) {
      this.getModulePages(3);
    }
    updateModule(SITE_MODULES.ACCOUNT);
    this.checkForSelectedUser();
    this.checkForCompanyId();
    const search = location?.search;
    const buttonRendered = document.getElementById("add-user-button");
    if (buttonRendered && buttonRendered.length !== 0 && !runHomeTour) {
      if (search.includes("tour=true")) {
        setHomeTour({ runHomeTour: true, action: "start" });
      }
    }

    const tour = location?.state?.tour;
    if (tour) {
      this.setState({ tourSelected: tour });
    }
  }
  updateBreadcrumbs = async (id) => {
    const { selectedModule } = this.state;
    this.setState({ currentId: id }, () => this.updatePages(selectedModule));

    this.setUserDetails(id);
  };

  setTicketId = (id) => {
    this.setState({ ticketId: id });
  };

  createDocumentParams = (type, location, email, id) => {
    if (type === "badge") {
      return {
        documentName:
          REACT_APP_ENV === "production"
            ? `${location.datacenter} DC Badge Request -${email}`
            : `${location.datacenter} DEV LAB DC Badge Request -${email}`,
        templateName: BadgeTemplateName,
        rosterUserId: null,
        email,
        organizationId: id,
        datacenterId: Utils.getLocationIDByTag(location.datacenter),
      };
    } else if (type === "access") {
      return {
        documentName:
          REACT_APP_ENV === "production"
            ? `${location.datacenter} DC Regulations -${email}`
            : `${location.datacenter} DEV LAB DC Regulations -${email}`,
        templateName: AccessTemplateName,
        rosterUserId: null,
        email,
        organizationId: id,
        datacenterId: Utils.getLocationIDByTag(location.datacenter),
      };
    }
  };

  sendMultipleSigningRequest = (multipleRequest) => {
    SigningServiceApi.sendMultipleSigningRequest(multipleRequest)
      .then((response) => {
        const validResponse = response.status === 200 && response.data?.success;

        if (validResponse) {
        } else {
        }
      })
      .catch(() => {});
  };

  sendDocument = (type, documentId, email, location, id) => {
    const { ticketId } = this.state;
    const signers =
      type === "badge"
        ? [
            // {
            // 	email: 'niamh-gilligan@live.ie',
            // 	role: 'Approver',
            // 	reminder: 3,
            // 	expiration_days: 15,
            // 	order: 1,
            // },
            {
              email,
              role: "Applicant",
              reminder: 3,
              expiration_days: 15,
              order: 2,
            },
          ]
        : [
            {
              email,
              role: "Signer 1",
              reminder: 3,
              expiration_days: 15,
              order: 1,
            },
          ];
    const singleRequest = {
      documentId,
      senderEmail: "itdev.dcblox@gmail.com",
      type,
      subject: "DCBLOX Datacenter Document " + location?.datacenter,
      message: "Please fill in this form.",
      datacenters: [location?.datacenter],
      organizationId: id,
      badgeRequired: type === "badge" ? true : false,
      signers,
      ticketId,
    };

    this.sendSingleSigningRequest(singleRequest);
  };

  sendSingleSigningRequest = (singleRequest) => {
    SigningServiceApi.sendSingleSigningRequest(singleRequest)
      .then((response) => {
        const validResponse = response.status === 200 && response.data?.success;

        if (validResponse) {
        }
      })
      .catch(() => {});
  };

  sendDocuments = (
    documentId1,
    documentId2,
    email,
    location,
    badgeAccess,
    id
  ) => {
    const { ticketId } = this.state;
    const signers = [
      {
        email,
        role: "Signer 1",
        reminder: 3,
        expiration_days: 31,
      },
      // {
      // 	email: 'niamh-gilligan@live.ie',
      // 	role: 'Approver',
      // 	reminder: 3,
      // 	expiration_days: 31,
      // },
      {
        email,
        role: "Applicant",
        reminder: 3,
        expiration_days: 31,
      },
    ];

    const multipleRequest = {
      email: "itdev.dcblox@gmail.com",
      subject:
        REACT_APP_ENV === "production"
          ? "DCBLOX Datacenter Documents " + location.datacenter
          : "DEV LAB DCBLOX Datacenter Documents " + location.datacenter,
      message: "Please fill in these forms.",
      documentIds: [documentId1, documentId2],
      datacenters: [location.datacenter],
      organizationId: id,
      badgeRequired: badgeAccess.includes("Yes") ? true : false,
      signers,
      ticketId,
    };
    this.sendMultipleSigningRequest(multipleRequest);
  };

  checkForSelectedUser = async () => {
    const userId = this.getUserId();
    const user = await this.getDefaultUser();

    if (userId) {
      this.updateBreadcrumbs(userId);
    } else if (user) {
      this.updateSelectedUser(user.userId);
      this.updateBreadcrumbs(user.userId);
    }
  };
  setUserDetails = (userId) => {
    const { organizationId } = this.state;

    UserApi.getUser(userId, organizationId)
      .then((response) => {
        const validResponse =
          response.status === 200 && response.data && !response.data.error;

        if (validResponse) {
          const user = response.data?.user;
          this.getRosterUserDetails(user?.userProfile?.emailAddress);
          this.setState({
            selectedUserDetails: user,
            currentId: user?.id,
            userDetailsLoaded: true,
            error: null,
          });
        } else {
          this.setState({
            error: "Error getting user details. Please contact support.",
            userDetailsLoaded: true,
          });
        }
      })
      .catch(() => {
        this.setState({
          error: "Error getting user details. Please contact support.",
          userDetailsLoaded: true,
        });
      });
  };

  getDefaultUser = async () => {
    const { users } = this.state;

    if (users && users.length) {
      return users[0];
    }
  };

  getUserId = () => {
    const { pathname } = window.location;
    const matches = pathname.split("/");

    if (matches) {
      const [, , , , userId] = matches;

      if (userId) {
        return userId;
      }
    }
  };

  checkPage = (pages, name) => {
    const PageToCheck = pages.filter((page) => page.displayName === name);

    if (!PageToCheck[0]?.permissions > 0) {
      throw new Error();
    }
  };

  componentDidUpdate(prevProps) {
    const { pathname } = window.location;
    const {
      location,
      setHomeTour,
      tour: { runHomeTour: { runHomeTour } } = {},
      permissions: pages,
    } = this.props;
    const matches = pathname.split("/");
    const { currentId, users, organizationId, tourClosed } = this.state;

    if (pages?.permissions) {
      this.checkPage(pages?.permissions, "Account Management");
    }
    if (matches) {
      const [, , , , selectedId] = matches;

      if (
        users &&
        selectedId &&
        currentId &&
        Number(selectedId) !== Number(currentId)
      ) {
        this.updateBreadcrumbs(selectedId);
      } else if (!selectedId) {
      }
    }
    if (!organizationId) {
      this.checkForCompanyId();
    }
    const search = location?.search;
    const buttonRendered = document.getElementById("add-user-button");

    if (
      buttonRendered &&
      buttonRendered.length !== 0 &&
      !runHomeTour &&
      !tourClosed
    ) {
      if (search.includes("tour=true")) {
        setHomeTour({ runHomeTour: true, action: "start" });
      }
    }
    const prevLocation = prevProps.location;

    if (location !== prevLocation) {
      const tour = location?.state?.tour;
      this.setState({ tourSelected: tour });
    }
  }
  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { loggedInUsersRole } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );
    if (currentMembershipSelected[0].role !== loggedInUsersRole) {
      this.setState({ loggedInUsersRole: currentMembershipSelected[0].role });
    }

    return currentMembershipSelected[0].role;
  };
  getRosterUserDetails = (email) => {
    if (!email) {
      return null;
    }

    DataCenterApi.getRosterUserByEmail(email)
      .then((response) => {
        const validResponse =
          response.status === 200 && response.data && !response.data.error;
        if (validResponse) {
          const rosterUser = response.data?.details;
          if (rosterUser && rosterUser?.id) {
            this.setState({ rosterUserDetails: rosterUser }, () =>
              this.getBadgeDetails(rosterUser?.id)
            );
          }
        }
      })
      .catch(() => {});
  };

  checkForCompanyId = () => {
    const {
      company_info: { customer: { id } = {} },
    } = this.props;
    const { organizationId: existingId, error } = this.state;

    if (id !== existingId && !error) {
      this.setState({ organizationId: id }, () => {
        this.getUsers(id);

        this.getUsersRole(id);
      });
    }
  };
  getUsers(id) {
    UserApi.getAllUsers(id)
      .then((response) => {
        const validResponse =
          response.status === 200 && response.data && !response.data.error;
        if (validResponse) {
          const sortedUsers = sortUsers(response.data.users);
          if (sortUsers && sortUsers.length !== 0) {
            this.setState({ users: sortedUsers, usersError: null }, () => {
              this.checkForSelectedUser();
            });
          } else {
            this.setState({ usersError: "Error pulling users" });
          }
        } else {
          this.setState({ usersError: "Error pulling users" });
        }
      })
      .catch(() => {
        this.setState({ usersError: "Error pulling users" });
      });
  }

  setToggleSelect = (selected) => {
    this.setState({ selectedToggle: selected });
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("account");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(3, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("account", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };

  getUserModulePages = async (serviceId, userId) => {
    const { selectedModule, organizationId } = this.state;
    const response = await Permissions.getUserModulePermissions(
      serviceId,
      userId,
      organizationId
    );
    const pages = response?.data?.pages;

    if (response && !response.data.error && pages.length !== 0) {
      this.setState({
        selectedUsersPages: response?.data?.pages,
        pagesError: null,
        pagesLoaded: true,
      });
    } else {
      const errorMessage = response?.data?.error
        ? response?.data?.error
        : `No permissions set for this user for the ${selectedModule} module.`;
      this.setState({
        selectedUsersPages: null,
        pagesError: errorMessage,
        pagesLoaded: true,
      });
    }
  };

  updatePages = (module) => {
    const { currentId } = this.state;
    let id = null;
    switch (module) {
      case "Account":
        id = 3;
        break;
      case "Billing":
        id = 4;
        break;
      case "Support":
        id = 2;
        break;
      case "Storage":
        id = 1;
        break;
      default:
        id = 3;
        break;
    }
    this.getUserModulePages(id, currentId);
  };
  getBadgeDetails = (rosterUserId) => {
    const params = {
      rosterUserId,
    };

    DataCenterApi.getBadgeDetails(params)
      .then((response) => {
        const validResponse =
          response.status === 200 && response.data && !response.data.error;
        if (validResponse) {
          this.setState({ badges: response?.data?.badges });
        } else {
          this.setState({ badges: [] });
        }
      })
      .catch(() => this.setState({ badges: [] }));
  };
  getSelectedUsersRole = () => {
    const { selectedUserDetails, users } = this.state;
    let role = "";
    if (!selectedUserDetails) {
      return role;
    }
    users &&
      users.filter((user) => {
        if (Number(user?.userId) === Number(selectedUserDetails.id)) {
          role = user?.role;
        }
      });
    return role;
  };

  getFields = (selectedUserDetails) => {
    if (!selectedUserDetails) {
      return null;
    }
    const { organizationId } = this.state;
    const { auth_status } = this.props;
    const { memberships = {} } = auth_status;
    const email = selectedUserDetails?.userProfile?.emailAddress;
    const badgeDetails = [];

    const currentMembershipSelected = memberships.filter(
      (membership) =>
        Number(membership.organizationId) === Number(organizationId)
    );
    const role = this.getSelectedUsersRole();

    let lastLogin = selectedUserDetails?.lastLogin;
    if (lastLogin) {
      lastLogin = format(new Date(lastLogin), "MM / dd / yy");
    }

    return {
      type: "horizontal",
      top: [
        { label: "Email", value: email },
        { label: currentMembershipSelected[0]?.organizationName, value: "" },
      ],
      bottom: [
        { label: "Role", value: role },
        { label: "Last Login", value: lastLogin },
        {
          label: "PHONE",
          value: selectedUserDetails?.contactDetailsResponse?.mobile_number,
        },
      ],
      left: [
        { label: currentMembershipSelected[0]?.organizationName, value: "" },
        { label: "Login", value: lastLogin },
        { label: "Permissions", value: selectedUserDetails?.role },
      ],
      right: badgeDetails,
    };
  };

  updateUserRole = async (role) => {
    const { selectedUserDetails, organizationId } = this.state;
    const { setModalContent } = this.props;
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    try {
      const response = await this.userProfileApi.updateUserRole({
        userId: selectedUserDetails?.id,
        orgId: organizationId,
        role,
      });

      if (response?.data?.success) {
        setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
        this.setState(
          { selectedUserDetails: null, users: null, userDetailsLoaded: false },
          () => {
            this.getUsers(organizationId);
          }
        );
      } else {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      }
    } catch (e) {
      console.log(e);
      setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
    }
  };

  updateUserPassword = async (password) => {
    const { selectedUserDetails, organizationId } = this.state;
    const { setModalContent } = this.props;
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    try {
      const response = await this.userProfileApi.updatePassword({
        passwordConfirm: password,
        newPassword: password,
        adminChange: true,
        email: selectedUserDetails?.userProfile?.emailAddress,
      });

      if (response?.data?.success) {
        setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
        this.setState(
          { selectedUserDetails: null, users: null, userDetailsLoaded: false },
          () => {
            this.getUsers(organizationId);
          }
        );
      } else {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      }
    } catch (e) {
      console.log(e);
      setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
    }
  };

  onAccept = async () => {
    const {
      organizationId,
      selectedUserDetails: { id: userId },
      selectedUserDetails,
    } = this.state;

    const enabled = !JSON.parse(selectedUserDetails?.enabled);
    setTimeout(() => {
      this.setState((state) => ({ ...state }));
    }, 1000);
    const confirmButton = document.getElementById("confirm-button-swipe");

    if (confirmButton) {
      confirmButton.classList.add("active");
    }
    setTimeout(() => {
      this.toggleActivationModal();
    }, 1000);

    try {
      const response = await this.userProfileApi.updatePortalUserActivation({
        userId,
        enabled,
        organizationId,
        role: selectedUserDetails?.role,
      });

      if (Utils.isValidResponse(response)) {
        this.setState(
          { selectedUserDetails: null, users: null, userDetailsLoaded: false },
          () => {
            this.getUsers(organizationId);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  updateSelectedUser = (selected) => {
    const { navigate, location } = this.props;
    this.setState({
      selectedUsersPages: null,
      badges: null,
      selectedUserDetails: null,
      userDetailsLoaded: false,
      pagesLoaded: false,
      rosterUserDetails: null,
    });

    let url = `/portal/account/account_management/${selected}`;

    const search = location?.search;

    const moduleOrder = location?.state?.moduleOrder;

    const tour = location?.state?.tour;

    if (search && search?.includes("tour=true")) {
      url = `/portal/account/account_management/${selected}?tour=true`;
    }

    if (tour) {
      navigate(url, { state: { tour } });
    } else if (selected) {
      navigate(url, { state: { moduleOrder } });
    }
  };
  setSelectedModule = (module) => {
    this.setState({ selectedModule: module }, () => {
      this.updatePages(module);
    });
  };
  handleFilterChange = (filterId, isChecked) => {
    this.setState((prevState) => {
      const { selectedFilters } = prevState;
      if (isChecked) {
        return { selectedFilters: [...selectedFilters, filterId] };
      } else {
        return {
          selectedFilters: selectedFilters.filter((id) => id !== filterId),
        };
      }
    });
  };

  handleRemoveFilter = (filterId) => {
    this.setState((prevState) => ({
      selectedFilters: prevState.selectedFilters.filter(
        (id) => id !== filterId
      ),
    }));
  };

  toggleActivationModal = () => {
    const { showActivationModal } = this.state;
    this.setState({ showActivationModal: !showActivationModal });
  };
  toggleShowAddUserModal = () => {
    const { showUserAddModal } = this.state;
    this.setState({ showUserAddModal: !showUserAddModal });
  };
  toggleShowAddDCModal = () => {
    const { showDCAddModal } = this.state;
    this.setState({ showDCAddModal: !showDCAddModal });
  };
  setStepIndex = (index) => {
    this.setState({ stepIndex: index });
  };
  handleTourCallback = (data) => {
    const { navigate, location } = this.props;
    const { action, index, status, type } = data;

    const addUserModal = document.getElementById("icon-button");
    if ([ACTIONS.CLOSE, ACTIONS.FINISHED].includes(action)) {
      this.setState({ tourSelected: null, stepIndex: 0 });

      if (addUserModal) {
        addUserModal.click();
      }
      navigate(location?.pathname);
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.setState({ tourSelected: null, stepIndex: 0 });
      if (addUserModal) {
        addUserModal.click();
      }
      navigate(location?.pathname);
    }
  };
  changeSelectedCompany = (id) => {
    const { navigate } = this.props;
    navigate(`/portal/account/account_management/`);

    this.setState({
      users: null,
      rosterUsers: null,
      selectedUserDetails: null,
      organizationId: id,
      rosterUserDetails: null,
      userDetailsLoaded: false,
    });

    this.getUsers(id);
  };

  goToNextModule = () => {
    const { location, navigate } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const nextIndex = moduleOrder[0];

      if (nextIndex) {
        const nextModule = SERVICE_IDS[nextIndex];
        const url = `/portal`;
        navigate(url, { state: { nextModule, moduleOrder } });
      }
    }
  };

  hasNextModule = () => {
    const { location } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const nextIndex = moduleOrder[0];

      if (!nextIndex) {
        return false;
      } else {
        return true;
      }
    }
  };

  getSize = (breakpoint) => {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  closeTour = (joyride) => {
    const { setHomeTour } = this.props;

    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
      this.setState({ tourClosed: true });
    }
  };

  getCustomCarousel = (memberships, breakpoint, site, organizationId) => {
    return (
      <CustomCarousel visibleItems={5}>
        {memberships.map((membership, index) => (
          <ActionButton
            id="special-id-1"
            breakpoint={breakpoint}
            onClick={() =>
              this.changeSelectedCompany(membership?.organizationId)
            }
            module={site?.module}
            enabled={membership?.role === "owner" ? true : false}
            className={
              Number(organizationId) === membership?.organizationId
                ? "small selected"
                : "small"
            }
            cypressId={`membership-${index}`}
          >
            <div className="org-name body10">
              <div className="name" style={{ color: "#7b868c" }}>
                {membership?.organizationName}
              </div>
            </div>
          </ActionButton>
        ))}
      </CustomCarousel>
    );
  };

  filterUsers = (users, selectedFilters) => {
    if (
      selectedFilters.includes("active") &&
      selectedFilters.includes("inactive")
    ) {
      return users;
    } else if (selectedFilters.includes("active")) {
      return users.filter((user) => user.active === true);
    } else if (selectedFilters.includes("inactive")) {
      return users.filter((user) => user.active === false);
    } else {
      return users;
    }
  };

  toggleBadgeModal = () => {
    const { showBadgeModal } = this.state;
    this.setState({ showBadgeModal: !showBadgeModal });
  };

  getProfileImage = (selectedUserEmpty, selectedUserDetails) => {
    return !selectedUserEmpty && selectedUserDetails?.userProfile
      ? this.avatarApi.get(selectedUserDetails?.userProfile?.profileImage)
      : this.avatarApi.getGenericAvatar();
  };
  getSelectedUserEmpty = (selectedUserDetails) => {
    return !selectedUserDetails || selectedUserDetails.length === 0
      ? true
      : false;
  };

  getUsersName = (selectedUserEmpty, selectedUserDetails) => {
    return !selectedUserEmpty
      ? `${selectedUserDetails?.firstname} ${selectedUserDetails?.lastname}`
      : "";
  };

  getPendingText = (selectedUserEmpty, selectedUserDetails) => {
    return !selectedUserEmpty && !JSON.parse(selectedUserDetails?.enabled)
      ? "activate"
      : "deactivate";
  };

  getConfigLayout = (memberships, breakpoint) => {
    return memberships.length !== 1
      ? LAYOUT_CONFIG[breakpoint]
      : LAYOUT_CONFIG2[breakpoint];
  };

  render() {
    const {
      breakpoint,
      location,
      company_info,
      auth_status,
      setModalContent,
      site,
      auth_status: { memberships },
      auth_status: {
        user: { id },
      },
      navigate,
      permissions: pages,
      tour: { runHomeTour: { runHomeTour } } = {},
    } = this.props;

    const {
      owners,
      users,
      usersError,
      error,
      currentId,
      organizationId,
      selectedUserDetails,
      showActivationModal,
      showBadgeModal,
      rosterUserDetails,
      selectedModule,
      selectedUsersPages,
      pagesError,
      pagesLoaded,
      selectedToggle,
      badges,
      showUserAddModal,
      showDCAddModal,
      tourSelected,
      stepIndex,
      userDetailsLoaded,
      selectedFilters,
    } = this.state;

    const hasViewUsersAccess = Permissions.checkComponentAccess(
      pages,
      "Account Management",
      "user-management"
    );
    const hasEditRosterUserAccess = Permissions.checkComponentAccess(
      pages,
      "Account Management",
      "edit-datacenter-user-status"
    );
    const hasEditUserStatusAccess = Permissions.checkComponentAccess(
      pages,
      "Account Management",
      "edit-users-status"
    );
    const hasEditUserPermAccess = Permissions.checkComponentAccess(
      pages,
      "Account Management",
      "edit-user-permissions"
    );
    const hasUserManagementAccess = Permissions.checkComponentAccess(
      pages,
      "Account Management",
      "user-management"
    );

    const hasUserPermissionEditAccess = Permissions.checkComponentAccess(
      pages,
      "Account Management",
      "edit-user-permissions"
    );
    const selectedUserEmpty = this.getSelectedUserEmpty(selectedUserDetails);

    const profileImage = this.getProfileImage(
      selectedUserEmpty,
      selectedUserDetails
    );

    const usersName = this.getUsersName(selectedUserEmpty, selectedUserDetails);
    const pendingText = this.getPendingText(
      selectedUserEmpty,
      selectedUserDetails
    );
    const module = site?.module;
    const isBeta = this.companyApi.isBetaOrg(organizationId, memberships);

    const FILTERS = [
      { id: "active", displayName: "Active Users" },
      { id: "inactive", displayName: "Inactive Users" },
    ];

    const steps = [
      {
        target: "#add-user-button",
        module: "account",
        disableBeacon: true,
        content:
          "This button will start the Add User process. I have a tour for this feature, and if you are interested, it will be available when this tour completes.",
      },
      {
        target: ".card-scroller",
        module: "account",
        content:
          "The list of users is ordered alphabetically and each item can be selected to load the profile into the page main area.",
      },
      {
        content:
          "When you select (click on) a user on the right side of the page, that user's permissions are managed here. Including enabling and disabling an entire module.",
        customNextButton: this.hasNextModule() ? (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="Next"
            module="account"
            enabled={true}
            onClick={this.goToNextModule}
            cypressId="continue-tour"
          />
        ) : null,
        target: ".permission-selector-container",
        locale: { next: "Finish" },
        module: "account",
      },
    ];

    return (
      <BloxPage
        name="page profile-user-management-page long"
        layout={this.getConfigLayout(memberships, breakpoint)}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`tourButton`} className="tourButton">
          {users && (
            <>
              <Joyride
                steps={steps}
                continuous={true}
                tooltipComponent={JoyRideToolTip}
                run={runHomeTour}
                styles={{
                  options: {
                    zIndex: 5000,
                  },
                }}
                module={module}
                callback={this.closeTour}
                spotlightPadding={5}
                disableScrolling={true}
                disableBeacon={true}
                disableOverlayClose={true}
              />
              <AddUserTour
                tourSelected={tourSelected}
                stepIndex={stepIndex}
                handleTourCallback={this.handleTourCallback}
                setStepIndex={this.setStepIndex}
              />
            </>
          )}
        </div>
        <div key={`accountManagement`} className="accountManagement">
          {organizationId && memberships.length !== 1 && (
            <ComponentWrapper title="Account Management" hideBorder>
              {this.getCustomCarousel(
                memberships,
                breakpoint,
                site,
                organizationId
              )}
            </ComponentWrapper>
          )}
        </div>
        <div key={`userDetails`} className="userDetails">
          <ComponentWrapper title={usersName} hideBorder>
            {!selectedUserEmpty && (
              <UserDetails
                owners={owners}
                image={profileImage}
                onClick={this.toggleActivationModal}
                addDataCenter={this.toggleShowAddDCModal}
                user={selectedUserDetails}
                fields={this.getFields(selectedUserDetails)}
                showToggle={true}
                selectedToggle={selectedToggle}
                switchToggle={this.setToggleSelect}
                modalToggle={this.toggleBadgeModal}
                rosterUser={rosterUserDetails}
                hasEditUserStatusAccess={hasEditUserStatusAccess}
                hasEditRosterUserAccess={hasEditRosterUserAccess}
                module={module}
                updateUserRole={this.updateUserRole}
                updateUserPassword={this.updateUserPassword}
                editRole={true}
                isUserManagement={true}
              />
            )}
            {!selectedUserEmpty && !error && !userDetailsLoaded && (
              <LoadingCube />
            )}
            {error && <div className="error-text body10">{error}</div>}
            {selectedUserEmpty && !error && userDetailsLoaded && (
              <div className="error-text body10">
                User details incomplete. Please contact support .
              </div>
            )}
          </ComponentWrapper>
          <PortraitModalComponent
            closeModal={this.toggleActivationModal}
            show={showActivationModal}
            header={
              <ModalHeader
                image={this.avatarApi.getGenericAvatar()}
                text={""}
              />
            }
            subTitle={"ARE you sure ?"}
            title="User Activation"
            size={this.getSize(breakpoint)}
            breakpoint={breakpoint}
          >
            <ActivationModalBody
              text={`Please confirm you want to ${pendingText} ${usersName} from this site. If you wish to remove data center access please submit a support ticket.`}
            />
            <ModalFooter
              cypressId="footer"
              id="footer"
              buttonText1={"Yes"}
              buttonText2="Back"
              buttonActive1={true}
              buttonActive2={true}
              module="account"
              buttonFunction1={this.onAccept}
              size={this.getSize(breakpoint)}
              buttonFunction2={this.toggleActivationModal}
            />
          </PortraitModalComponent>
          <PortraitModalComponent
            closeModal={this.toggleBadgeModal}
            show={showBadgeModal}
            header={
              <ModalHeader image={badgeIcon} text={""} className="guest" />
            }
            title="Badge Management"
            subTitle={"Badges"}
            size={this.getSize(breakpoint)}
            breakpoint={breakpoint}
          >
            <BadgeModal
              closeModal={this.toggleBadgeModal}
              setModalContent={setModalContent}
              badges={badges}
              rosterUser={rosterUserDetails}
              hasEditRosterUserAccess={hasEditRosterUserAccess}
              organizationId={organizationId}
              getBadgeDetails={this.getBadgeDetails}
            />
            <ModalFooter
              cypressId="footer"
              id="footer"
              buttonText1={"hello"}
              buttonText2="Back"
              buttonActive1={true}
              buttonActive2={true}
              module="account"
              size={this.getSize(breakpoint)}
            />
          </PortraitModalComponent>
        </div>
        <div key={`sitePermissions`} className="sitePermissions">
          {hasEditUserPermAccess && !usersError && (
            <ComponentWrapper title="Users Site Permissions" hideBorder>
              <SitePermissions
                pages={selectedUsersPages}
                selected={selectedModule}
                setSelected={this.setSelectedModule}
                user={selectedUserDetails}
                auth_status={auth_status}
                company_info={company_info}
                selectedId={currentId}
                setModalContent={setModalContent}
                error={pagesError}
                pagesLoaded={pagesLoaded}
                module={site?.module}
                organizationId={organizationId}
                usersRole={this.getSelectedUsersRole()}
                reloadPermissions={this.updatePages}
                hasUserPermissionEditAccess={hasUserPermissionEditAccess}
              />
            </ComponentWrapper>
          )}
          {!hasEditUserPermAccess && (
            <div className="body10">
              You do not have permission to edit permissions.
            </div>
          )}
        </div>

        <div key={`usersList`} className="usersList">
          <ComponentWrapper title="Users List" hideBorder>
            <>
              {isBeta && (
                <MultipleFilter
                  filters={FILTERS}
                  selectedFilters={selectedFilters}
                  removeTag={this.handleRemoveFilter}
                  handleFilterChange={this.handleFilterChange}
                  hasUserManagementAccess={hasUserManagementAccess}
                  toggleShowAddUserModal={this.toggleShowAddUserModal}
                  site={site}
                />
              )}
              {!isBeta && (
                <BloxButton
                  className="buttons41"
                  id="add-user-button"
                  text="Add User"
                  module={site?.module}
                  enabled={true}
                  onClick={this.toggleShowAddUserModal}
                  cypressId="add-user"
                />
              )}
              {users && hasViewUsersAccess && (
                <CardScroller
                  data={
                    isBeta ? this.filterUsers(users, selectedFilters) : users
                  }
                  onClick={this.updateSelectedUser}
                  selectedId={currentId}
                  showButton={true}
                />
              )}
              {!users && !usersError && <LoadingCube />}
              {usersError && (
                <div className="body10">
                  Error getting users. Please contact support.
                </div>
              )}
              {users && (
                <AddUserDataProvider>
                  <UserAddRequest
                    owners={owners}
                    breakpoint={breakpoint}
                    closeModal={this.toggleShowAddUserModal}
                    showModal={showUserAddModal}
                    id={organizationId}
                    refreshUsers={() => this.getUsers(organizationId)}
                    setModalContent={setModalContent}
                    rosterUser={rosterUserDetails}
                    navigate={navigate}
                    location={location}
                    currentUserId={id}
                    loggedInUserId={auth_status?.user?.id}
                    setTicketId={this.setTicketId}
                    users={users}
                  />
                  {showDCAddModal && (
                    <BadgeAddRequest
                      breakpoint={breakpoint}
                      closeModal={this.toggleShowAddDCModal}
                      showModal={showDCAddModal}
                      id={organizationId}
                      refreshUsers={() => this.getUsers(organizationId)}
                      setModalContent={setModalContent}
                      navigate={navigate}
                      user={selectedUserDetails}
                      rosterUser={rosterUserDetails}
                      currentUserId={currentId}
                      loggedInUserId={auth_status?.user?.id}
                      auth_status={auth_status}
                      setTicketId={this.setTicketId}
                    />
                  )}
                </AddUserDataProvider>
              )}
            </>
          </ComponentWrapper>
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updateUsers,
  updatePermissions,
  setHomeTour,
})(UserMgmtPage);
